import { Route, Routes } from "react-router-dom";

import { Schedule } from "./components/Schedule/Schedule.jsx";
import { Cabinet } from "./components/Cabinet/Cabinet.jsx";

function App() {
  return (
    <Routes>
      <Route path="/schedule/*" element={<Schedule />} />
      <Route path="/cabinet/*" element={<Cabinet />} />
    </Routes>
  );
}

export default App;
